import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

console.error('[Bootstrap] starting Angular bootstrap');

bootstrapApplication(App, appConfig)
  .then(() => {
    console.error('[Bootstrap] Angular bootstrap completed');
  })
  .catch((err) => {
    console.error('[Bootstrap] Angular bootstrap failed', err);
  });
